import { APP_NAVIGATION, ROUTE_CONSTANT } from "./Constants";

export const PathHelper = (sectionName: string) => {
  const pathValue = {
    next: ROUTE_CONSTANT.HOME,
    cstm: ROUTE_CONSTANT.HOME,
  };

  const replacePathAfterDomain = (url: string) => {
    const domain = window.location.origin;
    const indexOfDomainEnd = url.indexOf(domain) + domain.length;
    return url.substring(0, indexOfDomainEnd);
  };
  switch (sectionName) {
    case APP_NAVIGATION.TEMP:
      pathValue.next = ROUTE_CONSTANT.SIGNUP;
      pathValue.cstm = ROUTE_CONSTANT.USER_DASHBOARD;
      break;
    case APP_NAVIGATION.SINU:
      pathValue.next = ROUTE_CONSTANT.PAYMENT_PLAN;
      break;
    case APP_NAVIGATION.SINI:
      pathValue.next = ROUTE_CONSTANT.USER_DASHBOARD;
      pathValue.cstm = ROUTE_CONSTANT.PAYMENT_PLAN;
      break;
    case APP_NAVIGATION.PLAN:
      pathValue.next = ROUTE_CONSTANT.CHECKOUT_PAGE;
      break;
    case APP_NAVIGATION.CHPG:
      pathValue.next = ROUTE_CONSTANT.PAYMENT_CONFIRMATION;
      break;
    case APP_NAVIGATION.CONPG:
      pathValue.next = replacePathAfterDomain(ROUTE_CONSTANT.CONTACT);
      break;
    case APP_NAVIGATION.TERMS:
      pathValue.next = replacePathAfterDomain(ROUTE_CONSTANT.TERMSNCOND);
      break;
    case APP_NAVIGATION.PRVCY:
      pathValue.next = replacePathAfterDomain(ROUTE_CONSTANT.PRIVACY);
      break;
    case APP_NAVIGATION.ABTPG:
      pathValue.next = replacePathAfterDomain(ROUTE_CONSTANT.ABOUT);
      break;
    case APP_NAVIGATION.LANDING:
      pathValue.next = replacePathAfterDomain(ROUTE_CONSTANT.LANDINGPAGE);
      break;
    default:
      pathValue.next = ROUTE_CONSTANT.HOME;
      break;
  }
  return pathValue;
};

export default PathHelper;
